import React, { CSSProperties } from 'react'
import styled from 'styled-components'

export const iconsList = {
    answerAccepted: (
        <svg
            width="11"
            height="10"
            viewBox="0 0 11 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.543 5C10.543 7.76142 8.30439 10 5.54297 10C2.78154 10 0.542969 7.76142 0.542969 5C0.542969 2.23858 2.78154 0 5.54297 0C8.30439 0 10.543 2.23858 10.543 5ZM4.23417 4.53446C4.29517 4.56066 4.35034 4.59876 4.39647 4.64651L5.04297 5.29301L6.68947 3.64651C6.73559 3.59876 6.79076 3.56066 6.85177 3.53446C6.91277 3.50826 6.97838 3.49446 7.04477 3.49388C7.11116 3.49331 7.177 3.50596 7.23844 3.5311C7.29989 3.55624 7.35572 3.59337 7.40266 3.64031C7.44961 3.68726 7.48674 3.74309 7.51188 3.80453C7.53702 3.86598 7.54967 3.93182 7.54909 3.99821C7.54852 4.0646 7.53472 4.13021 7.50852 4.19121C7.48231 4.25221 7.44422 4.30739 7.39647 4.35351L5.39647 6.35351C5.3027 6.44725 5.17555 6.4999 5.04297 6.4999C4.91039 6.4999 4.78323 6.44725 4.68947 6.35351L3.68947 5.35351C3.64171 5.30739 3.60362 5.25221 3.57742 5.19121C3.55121 5.13021 3.53742 5.0646 3.53684 4.99821C3.53627 4.93182 3.54892 4.86598 3.57406 4.80453C3.5992 4.74308 3.63632 4.68726 3.68327 4.64031C3.73022 4.59337 3.78604 4.55624 3.84749 4.5311C3.90894 4.50596 3.97478 4.49331 4.04117 4.49389C4.10756 4.49446 4.17317 4.50826 4.23417 4.53446Z"
                fill="#00ADE0"
            />
        </svg>
    ),
    answerReadyForReview: (
        <svg
            width="13"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.07283 0.0181973C6.22815 0.00613129 6.38494 0 6.54297 0C6.701 0 6.85779 0.00613129 7.01311 0.0181973L8.0101 0.0956516L7.85519 2.08964L6.8582 2.01219C6.75437 2.00412 6.64925 2 6.54297 2C6.43669 2 6.33157 2.00412 6.22774 2.01219L5.23074 2.08964L5.07584 0.0956516L6.07283 0.0181973ZM9.67994 0.787972L10.44 1.43777C10.6787 1.64181 10.9012 1.86425 11.1052 2.10292L11.755 2.86303L10.2348 4.16263L9.58499 3.40252C9.44863 3.24302 9.29995 3.09434 9.14045 2.95798L8.38034 2.30818L9.67994 0.787972ZM4.7056 2.30818L3.94549 2.95798C3.78599 3.09434 3.63731 3.24302 3.50095 3.40252L2.85115 4.16263L1.33094 2.86303L1.98074 2.10292C2.18478 1.86425 2.40722 1.64181 2.64589 1.43777L3.406 0.787973L4.7056 2.30818ZM2.63261 4.68777L2.55516 5.68477C2.54709 5.7886 2.54297 5.89372 2.54297 6C2.54297 6.10628 2.54709 6.2114 2.55516 6.31523L2.63261 7.31222L0.63862 7.46713L0.561166 6.47014C0.5491 6.31482 0.542969 6.15803 0.542969 6C0.542969 5.84197 0.5491 5.68518 0.561166 5.52986L0.63862 4.53287L2.63261 4.68777ZM12.4473 4.53287L12.5248 5.52986C12.5368 5.68518 12.543 5.84197 12.543 6C12.543 6.15803 12.5368 6.31482 12.5248 6.47014L12.4473 7.46713L10.4533 7.31223L10.5308 6.31523C10.5388 6.2114 10.543 6.10628 10.543 6C10.543 5.89372 10.5388 5.7886 10.5308 5.68477L10.4533 4.68777L12.4473 4.53287ZM2.85115 7.83737L3.50095 8.59748C3.63731 8.75698 3.78599 8.90566 3.94549 9.04202L4.7056 9.69182L3.406 11.212L2.64589 10.5622C2.40722 10.3582 2.18478 10.1357 1.98074 9.89708L1.33094 9.13697L2.85115 7.83737ZM11.755 9.13697L11.1052 9.89708C10.9012 10.1357 10.6787 10.3582 10.44 10.5622L9.67994 11.212L8.38034 9.69182L9.14045 9.04202C9.29995 8.90566 9.44863 8.75698 9.58499 8.59748L10.2348 7.83737L11.755 9.13697ZM5.23074 9.91036L6.22774 9.98781C6.33157 9.99588 6.43669 10 6.54297 10C6.64925 10 6.75437 9.99588 6.8582 9.98781L7.85519 9.91036L8.0101 11.9043L7.01311 11.9818C6.85779 11.9939 6.701 12 6.54297 12C6.38494 12 6.22815 11.9939 6.07283 11.9818L5.07583 11.9043L5.23074 9.91036Z"
                fill="#A3ACBA"
            />
        </svg>
    ),
    answerRejected: (
        <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5C10 7.76142 7.76142 10 5 10ZM5.88388 5L7.31694 6.43306C7.56102 6.67714 7.56102 7.07286 7.31694 7.31694C7.07286 7.56102 6.67714 7.56102 6.43306 7.31694L5 5.88388L3.56694 7.31694C3.32286 7.56102 2.92714 7.56102 2.68306 7.31694C2.43898 7.07286 2.43898 6.67714 2.68306 6.43306L4.11612 5L2.68306 3.56694C2.43898 3.32286 2.43898 2.92714 2.68306 2.68306C2.92714 2.43898 3.32286 2.43898 3.56694 2.68306L5 4.11612L6.43306 2.68306C6.67714 2.43898 7.07286 2.43898 7.31694 2.68306C7.56102 2.92714 7.56102 3.32286 7.31694 3.56694L5.88388 5Z"
                fill="#DF1B41"
            />
        </svg>
    ),
    arrowCircleDown: (
        <svg
            width="14"
            height="14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#arrowCircleDown)">
                <path
                    d="M9.916 1.947a5.833 5.833 0 1 1-5.833 0M4.666 7l2.333 2.333m0 0L9.333 7M6.999 9.333V1.167"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="arrowCircleDown">
                    <path fill="#fff" d="M0 0h14v14H0z" />
                </clipPath>
            </defs>
        </svg>
    ),
    barChart: (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6 11.25V12.75M9 8.25V12.75M12 5.25V12.75M5.85 15.75H12.15C13.4101 15.75 14.0402 15.75 14.5215 15.5048C14.9448 15.289 15.289 14.9448 15.5048 14.5215C15.75 14.0402 15.75 13.4101 15.75 12.15V5.85C15.75 4.58988 15.75 3.95982 15.5048 3.47852C15.289 3.05516 14.9448 2.71095 14.5215 2.49524C14.0402 2.25 13.4101 2.25 12.15 2.25H5.85C4.58988 2.25 3.95982 2.25 3.47852 2.49524C3.05516 2.71095 2.71095 3.05516 2.49524 3.47852C2.25 3.95982 2.25 4.58988 2.25 5.85V12.15C2.25 13.4101 2.25 14.0402 2.49524 14.5215C2.71095 14.9448 3.05516 15.289 3.47852 15.5048C3.95982 15.75 4.58988 15.75 5.85 15.75Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    barChartSmall: (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.33333 9V10.3333M7 6.33333V10.3333M9.66667 3.66667V10.3333M4.2 13H9.8C10.9201 13 11.4802 13 11.908 12.782C12.2843 12.5903 12.5903 12.2843 12.782 11.908C13 11.4802 13 10.9201 13 9.8V4.2C13 3.0799 13 2.51984 12.782 2.09202C12.5903 1.71569 12.2843 1.40973 11.908 1.21799C11.4802 1 10.9201 1 9.8 1H4.2C3.0799 1 2.51984 1 2.09202 1.21799C1.71569 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.0799 1 4.2V9.8C1 10.9201 1 11.4802 1.21799 11.908C1.40973 12.2843 1.71569 12.5903 2.09202 12.782C2.51984 13 3.0799 13 4.2 13Z"
                stroke="#6A7383"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    building: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="16" height="16" rx="8" fill="#E8EBEF" />
            <path
                d="M5.00065 4.66667H6.83398M5.00065 7.33333H6.83398M5.00065 10H6.83398M9.16732 4.66667H11.0007M9.16732 7.33333H11.0007M9.16732 10H11.0007M13.334 14V4.13333C13.334 3.3866 13.334 3.01323 13.1887 2.72801C13.0608 2.47713 12.8569 2.27316 12.606 2.14532C12.3208 2 11.9474 2 11.2007 2H4.80065C4.05391 2 3.68055 2 3.39533 2.14532C3.14445 2.27316 2.94047 2.47713 2.81264 2.72801C2.66732 3.01323 2.66732 3.3866 2.66732 4.13333V14M14.6673 14H1.33398"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    calendar: (
        <svg
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13 6.66671H1M9.66667 1.33337V4.00004M4.33333 1.33337V4.00004M4.2 14.6667H9.8C10.9201 14.6667 11.4802 14.6667 11.908 14.4487C12.2843 14.257 12.5903 13.951 12.782 13.5747C13 13.1469 13 12.5868 13 11.4667V5.86671C13 4.7466 13 4.18655 12.782 3.75873C12.5903 3.3824 12.2843 3.07644 11.908 2.88469C11.4802 2.66671 10.9201 2.66671 9.8 2.66671H4.2C3.0799 2.66671 2.51984 2.66671 2.09202 2.88469C1.71569 3.07644 1.40973 3.3824 1.21799 3.75873C1 4.18655 1 4.7466 1 5.86671V11.4667C1 12.5868 1 13.1469 1.21799 13.5747C1.40973 13.951 1.71569 14.257 2.09202 14.4487C2.51984 14.6667 3.0799 14.6667 4.2 14.6667Z"
                stroke="#6A7383"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    camera: (
        <svg
            width="24"
            height="20"
            viewBox="0 0 24 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M23 17C23 17.5304 22.7893 18.0391 22.4142 18.4142C22.0391 18.7893 21.5304 19 21 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V6C1 5.46957 1.21071 4.96086 1.58579 4.58579C1.96086 4.21071 2.46957 4 3 4H7L9 1H15L17 4H21C21.5304 4 22.0391 4.21071 22.4142 4.58579C22.7893 4.96086 23 5.46957 23 6V17Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 15C14.2091 15 16 13.2091 16 11C16 8.79086 14.2091 7 12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    check: (
        <svg
            width="12"
            height="9"
            viewBox="0 0 12 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 1L4.125 8L1 4.81818"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    checkSmall: (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.6668 3.5L5.25016 9.91667L2.3335 7"
                stroke="#30313C"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    chevronDown: (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.1935 3.96987C10.4867 3.67671 10.962 3.67671 11.2552 3.96987C11.5483 4.26304 11.5483 4.73835 11.2552 5.03152L6.53035 9.75631C6.23746 10.0492 5.76259 10.0492 5.4697 9.75631L0.744898 5.03152C0.451733 4.73835 0.451733 4.26304 0.744898 3.96987C1.03806 3.67671 1.51338 3.67671 1.80654 3.96987L6.00002 8.16336L10.1935 3.96987Z"
                fill="currentColor"
            />
        </svg>
    ),
    chevronDownSmall: (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3 4.5L6 7.5L9 4.5"
                stroke="#30313C"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    chevronRight: (
        <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.5 6.86304L4.5 3.86304L1.5 0.863037"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    chevronUpSmall: (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9 7.5L6 4.5L3 7.5"
                stroke="#30313C"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    circlePlus: (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6 4V8M4 6H8M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z"
                stroke="#6A7383"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    clear: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM10.9997 10.2161C10.9997 10.0082 10.917 9.80893 10.77 9.662L9.108 8L10.77 6.338C10.8428 6.26525 10.9005 6.17888 10.9398 6.08383C10.9792 5.98877 10.9995 5.88689 10.9995 5.784C10.9995 5.68112 10.9792 5.57924 10.9398 5.48418C10.9005 5.38912 10.8428 5.30276 10.77 5.23C10.6973 5.15725 10.6109 5.09954 10.5158 5.06017C10.4208 5.02079 10.3189 5.00053 10.216 5.00053C10.1131 5.00053 10.0112 5.02079 9.91618 5.06017C9.82112 5.09954 9.73475 5.15725 9.662 5.23L8 6.892L6.33734 5.23C6.18866 5.09184 5.9922 5.01672 5.78928 5.02043C5.58635 5.02415 5.39278 5.10642 5.24926 5.24993C5.10575 5.39344 5.02348 5.58702 5.01976 5.78995C5.01605 5.99287 5.09117 6.18933 5.22934 6.338L6.89134 8L5.22934 9.662C5.08233 9.80903 4.99975 10.0084 4.99975 10.2163C4.99975 10.4242 5.08233 10.6236 5.22934 10.7707C5.30194 10.8437 5.38827 10.9016 5.48334 10.9411C5.57842 10.9807 5.68037 11.001 5.78334 11.001C5.8863 11.001 5.98825 10.9807 6.08333 10.9411C6.1784 10.9016 6.26473 10.8437 6.33734 10.7707L8 9.108L9.662 10.7707C9.80902 10.9176 10.0084 11.0001 10.2162 11C10.4241 11 10.6234 10.9174 10.7703 10.7703C10.9173 10.6233 10.9998 10.424 10.9997 10.2161Z"
                fill="currentColor"
            />
        </svg>
    ),
    close: (
        <svg
            width="7"
            height="8"
            viewBox="0 0 7 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.62326 0.933336L3.50059 3.05667L1.37659 0.932669C1.31308 0.870562 1.22768 0.835953 1.13885 0.836327C1.05002 0.836702 0.964908 0.872029 0.901924 0.934669L0.435257 1.402C0.403311 1.43265 0.377843 1.4694 0.360364 1.51007C0.342885 1.55074 0.33375 1.5945 0.333501 1.63877C0.333253 1.68304 0.341895 1.72691 0.358916 1.76777C0.375938 1.80864 0.400991 1.84567 0.432591 1.87667L2.55592 3.99934L0.433258 6.12334C0.371239 6.18693 0.336749 6.27239 0.337248 6.36122C0.337747 6.45004 0.373195 6.53511 0.435924 6.598L0.902591 7.06467C1.03992 7.20267 1.24659 7.198 1.37726 7.06734L3.50126 4.944L5.62392 7.06734C5.68752 7.12935 5.77298 7.16384 5.8618 7.16334C5.95063 7.16285 6.0357 7.1274 6.09859 7.06467L6.56593 6.598C6.59783 6.56731 6.62324 6.53053 6.64067 6.48983C6.65809 6.44914 6.66716 6.40536 6.66735 6.36109C6.66753 6.31682 6.65883 6.27297 6.64175 6.23213C6.62467 6.19129 6.59957 6.15429 6.56792 6.12334L4.44392 3.99934L6.56792 1.87667C6.63003 1.81316 6.66464 1.72775 6.66427 1.63893C6.66389 1.5501 6.62857 1.46499 6.56593 1.402L6.09926 0.935336C6.06798 0.903318 6.03066 0.877817 5.98947 0.86031C5.94828 0.842802 5.90402 0.833634 5.85926 0.833336C5.81538 0.833695 5.77201 0.842713 5.73162 0.859873C5.69124 0.877034 5.65464 0.901999 5.62392 0.933336H5.62326Z"
                fill="currentColor"
            />
        </svg>
    ),
    close2: (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 0.863037L1 10.863M1 0.863037L11 10.863"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    copy: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2321_9943)">
                <path
                    d="M10.6673 10.6668V12.5335C10.6673 13.2802 10.6673 13.6536 10.522 13.9388C10.3942 14.1897 10.1902 14.3937 9.93931 14.5215C9.65409 14.6668 9.28072 14.6668 8.53398 14.6668H3.46732C2.72058 14.6668 2.34721 14.6668 2.062 14.5215C1.81111 14.3937 1.60714 14.1897 1.47931 13.9388C1.33398 13.6536 1.33398 13.2802 1.33398 12.5335V7.46683C1.33398 6.72009 1.33398 6.34672 1.47931 6.06151C1.60714 5.81063 1.81111 5.60665 2.062 5.47882C2.34721 5.3335 2.72058 5.3335 3.46732 5.3335H5.33398M7.46732 10.6668H12.534C13.2807 10.6668 13.6541 10.6668 13.9393 10.5215C14.1902 10.3937 14.3942 10.1897 14.522 9.93882C14.6673 9.6536 14.6673 9.28023 14.6673 8.5335V3.46683C14.6673 2.72009 14.6673 2.34672 14.522 2.06151C14.3942 1.81063 14.1902 1.60665 13.9393 1.47882C13.6541 1.3335 13.2807 1.3335 12.534 1.3335H7.46732C6.72058 1.3335 6.34721 1.3335 6.062 1.47882C5.81111 1.60665 5.60714 1.81063 5.47931 2.06151C5.33398 2.34672 5.33398 2.72009 5.33398 3.46683V8.5335C5.33398 9.28023 5.33398 9.6536 5.47931 9.93882C5.60714 10.1897 5.81111 10.3937 6.062 10.5215C6.34721 10.6668 6.72058 10.6668 7.46732 10.6668Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2321_9943">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    ),
    database: (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.75 3.75C15.75 4.99264 12.7279 6 9 6C5.27208 6 2.25 4.99264 2.25 3.75M15.75 3.75C15.75 2.50736 12.7279 1.5 9 1.5C5.27208 1.5 2.25 2.50736 2.25 3.75M15.75 3.75V14.25C15.75 15.495 12.75 16.5 9 16.5C5.25 16.5 2.25 15.495 2.25 14.25V3.75M15.75 9C15.75 10.245 12.75 11.25 9 11.25C5.25 11.25 2.25 10.245 2.25 9"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    dots: (
        <svg
            width="14"
            height="4"
            viewBox="0 0 14 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.75 3.75C2.7165 3.75 3.5 2.9665 3.5 2C3.5 1.0335 2.7165 0.25 1.75 0.25C0.783502 0.25 0 1.0335 0 2C0 2.9665 0.783502 3.75 1.75 3.75Z"
                fill="currentColor"
            />
            <path
                d="M7 3.75C7.9665 3.75 8.75 2.9665 8.75 2C8.75 1.0335 7.9665 0.25 7 0.25C6.0335 0.25 5.25 1.0335 5.25 2C5.25 2.9665 6.0335 3.75 7 3.75Z"
                fill="currentColor"
            />
            <path
                d="M14 2C14 2.9665 13.2165 3.75 12.25 3.75C11.2835 3.75 10.5 2.9665 10.5 2C10.5 1.0335 11.2835 0.25 12.25 0.25C13.2165 0.25 14 1.0335 14 2Z"
                fill="currentColor"
            />
        </svg>
    ),
    download: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 10L12 15M12 15L7 10M12 15V3"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    dropdownIcon: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.66699 9.99996L8.00033 13.3333L11.3337 9.99996M4.66699 5.99996L8.00033 2.66663L11.3337 5.99996"
                stroke="#6A7383"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    external: (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.5 3V10.5H9V8.25C9 7.83579 9.33579 7.5 9.75 7.5C10.1642 7.5 10.5 7.83579 10.5 8.25V11.25C10.5 11.6642 10.1642 12 9.75 12H0.75C0.335786 12 0 11.6642 0 11.25V2.25C0 1.83579 0.335786 1.5 0.75 1.5H3.75C4.16421 1.5 4.5 1.83579 4.5 2.25C4.5 2.66421 4.16421 3 3.75 3H1.5ZM5.78033 7.28033C5.48744 7.57322 5.01256 7.57322 4.71967 7.28033C4.42678 6.98744 4.42678 6.51256 4.71967 6.21967L9.44524 1.49654H6.7621C6.34884 1.49654 6.01383 1.16153 6.01383 0.748272C6.01383 0.335013 6.34884 0 6.7621 0L11.2517 0C11.4432 0 11.6347 0.0730545 11.7808 0.219164C11.9269 0.365273 12 0.556772 12 0.748272V5.2379C12 5.65116 11.665 5.98617 11.2517 5.98617C10.8385 5.98617 10.5035 5.65116 10.5035 5.2379V2.55476L5.78033 7.28033Z"
                fill="currentColor"
            />
        </svg>
    ),
    exportArrow: (
        <svg
            width="9"
            height="8"
            viewBox="0 0 9 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.99998 5.00306C7.99998 5.27935 7.77602 5.50333 7.49977 5.50333C7.22351 5.50333 6.99956 5.27935 6.99956 5.00306V2.20278L1.6972 7.50462C1.50338 7.69846 1.18915 7.69846 0.995336 7.50462C0.801522 7.31078 0.801522 6.9965 0.995336 6.80266L6.29769 1.50083H3.49787C3.22161 1.50083 2.99766 1.27685 2.99766 1.00055C2.99766 0.724254 3.22161 0.500271 3.49787 0.500271H7.46841C7.48148 0.499892 7.49443 0.49991 7.50724 0.500326C7.55669 0.501051 7.60441 0.508953 7.6494 0.523039C7.72663 0.546285 7.79611 0.587136 7.85462 0.645652C7.95202 0.743067 8.00047 0.870901 7.99997 0.998579L7.99998 5.00306Z"
                fill="currentColor"
            />
        </svg>
    ),
    eye: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    eyeOff: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    filter: (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3 6H9M1.5 3H10.5M4.5 9H7.5"
                stroke="#30313D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    folder: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.66634 4.66667L7.92265 3.17928C7.70861 2.7512 7.60158 2.53715 7.44192 2.38078C7.30073 2.24249 7.13056 2.13732 6.94372 2.07287C6.73245 2 6.49315 2 6.01454 2H3.46634C2.7196 2 2.34624 2 2.06102 2.14532C1.81014 2.27316 1.60616 2.47713 1.47833 2.72801C1.33301 3.01323 1.33301 3.3866 1.33301 4.13333V4.66667M1.33301 4.66667H11.4663C12.5864 4.66667 13.1465 4.66667 13.5743 4.88465C13.9506 5.0764 14.2566 5.38236 14.4484 5.75869C14.6663 6.18651 14.6663 6.74656 14.6663 7.86667V10.8C14.6663 11.9201 14.6663 12.4802 14.4484 12.908C14.2566 13.2843 13.9506 13.5903 13.5743 13.782C13.1465 14 12.5864 14 11.4663 14H4.53301C3.4129 14 2.85285 14 2.42503 13.782C2.0487 13.5903 1.74274 13.2843 1.55099 12.908C1.33301 12.4802 1.33301 11.9201 1.33301 10.8V4.66667Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    globe: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_958_8378)">
                <path
                    d="M1.33301 8.00016H14.6663M1.33301 8.00016C1.33301 11.6821 4.31778 14.6668 7.99967 14.6668M1.33301 8.00016C1.33301 4.31826 4.31778 1.3335 7.99967 1.3335M14.6663 8.00016C14.6663 11.6821 11.6816 14.6668 7.99967 14.6668M14.6663 8.00016C14.6663 4.31826 11.6816 1.3335 7.99967 1.3335M7.99967 1.3335C9.66719 3.15906 10.6148 5.52819 10.6663 8.00016C10.6148 10.4721 9.66719 12.8413 7.99967 14.6668M7.99967 1.3335C6.33215 3.15906 5.38451 5.52819 5.33301 8.00016C5.38451 10.4721 6.33215 12.8413 7.99967 14.6668"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_958_8378">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    ),
    grid: (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.3 2.25H3.45C3.02996 2.25 2.81994 2.25 2.65951 2.33175C2.51839 2.40365 2.40365 2.51839 2.33175 2.65951C2.25 2.81994 2.25 3.02996 2.25 3.45V6.3C2.25 6.72004 2.25 6.93006 2.33175 7.09049C2.40365 7.23161 2.51839 7.34635 2.65951 7.41825C2.81994 7.5 3.02996 7.5 3.45 7.5H6.3C6.72004 7.5 6.93006 7.5 7.09049 7.41825C7.23161 7.34635 7.34635 7.23161 7.41825 7.09049C7.5 6.93006 7.5 6.72004 7.5 6.3V3.45C7.5 3.02996 7.5 2.81994 7.41825 2.65951C7.34635 2.51839 7.23161 2.40365 7.09049 2.33175C6.93006 2.25 6.72004 2.25 6.3 2.25Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.55 2.25H11.7C11.28 2.25 11.0699 2.25 10.9095 2.33175C10.7684 2.40365 10.6537 2.51839 10.5817 2.65951C10.5 2.81994 10.5 3.02996 10.5 3.45V6.3C10.5 6.72004 10.5 6.93006 10.5817 7.09049C10.6537 7.23161 10.7684 7.34635 10.9095 7.41825C11.0699 7.5 11.28 7.5 11.7 7.5H14.55C14.97 7.5 15.1801 7.5 15.3405 7.41825C15.4816 7.34635 15.5963 7.23161 15.6683 7.09049C15.75 6.93006 15.75 6.72004 15.75 6.3V3.45C15.75 3.02996 15.75 2.81994 15.6683 2.65951C15.5963 2.51839 15.4816 2.40365 15.3405 2.33175C15.1801 2.25 14.97 2.25 14.55 2.25Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.55 10.5H11.7C11.28 10.5 11.0699 10.5 10.9095 10.5817C10.7684 10.6537 10.6537 10.7684 10.5817 10.9095C10.5 11.0699 10.5 11.28 10.5 11.7V14.55C10.5 14.97 10.5 15.1801 10.5817 15.3405C10.6537 15.4816 10.7684 15.5963 10.9095 15.6683C11.0699 15.75 11.28 15.75 11.7 15.75H14.55C14.97 15.75 15.1801 15.75 15.3405 15.6683C15.4816 15.5963 15.5963 15.4816 15.6683 15.3405C15.75 15.1801 15.75 14.97 15.75 14.55V11.7C15.75 11.28 15.75 11.0699 15.6683 10.9095C15.5963 10.7684 15.4816 10.6537 15.3405 10.5817C15.1801 10.5 14.97 10.5 14.55 10.5Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.3 10.5H3.45C3.02996 10.5 2.81994 10.5 2.65951 10.5817C2.51839 10.6537 2.40365 10.7684 2.33175 10.9095C2.25 11.0699 2.25 11.28 2.25 11.7V14.55C2.25 14.97 2.25 15.1801 2.33175 15.3405C2.40365 15.4816 2.51839 15.5963 2.65951 15.6683C2.81994 15.75 3.02996 15.75 3.45 15.75H6.3C6.72004 15.75 6.93006 15.75 7.09049 15.6683C7.23161 15.5963 7.34635 15.4816 7.41825 15.3405C7.5 15.1801 7.5 14.97 7.5 14.55V11.7C7.5 11.28 7.5 11.0699 7.41825 10.9095C7.34635 10.7684 7.23161 10.6537 7.09049 10.5817C6.93006 10.5 6.72004 10.5 6.3 10.5Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    home: (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.73673 2.073C9.47324 1.86806 9.34149 1.76559 9.19601 1.7262C9.06765 1.69145 8.93235 1.69145 8.80399 1.7262C8.65851 1.76559 8.52677 1.86806 8.26327 2.073L3.17654 6.02934C2.83652 6.29381 2.6665 6.42604 2.54402 6.59164C2.43552 6.73833 2.3547 6.90359 2.30552 7.07929C2.25 7.27764 2.25 7.49302 2.25 7.92379V13.35C2.25 14.1901 2.25 14.6101 2.41349 14.931C2.5573 15.2132 2.78677 15.4427 3.06901 15.5865C3.38988 15.75 3.80992 15.75 4.65 15.75H6.15C6.36002 15.75 6.46503 15.75 6.54525 15.7091C6.61581 15.6732 6.67317 15.6158 6.70913 15.5452C6.75 15.465 6.75 15.36 6.75 15.15V10.2C6.75 9.77995 6.75 9.56993 6.83175 9.4095C6.90365 9.26837 7.01839 9.15364 7.15951 9.08173C7.31994 8.99999 7.52996 8.99999 7.95 8.99999H10.05C10.47 8.99999 10.6801 8.99999 10.8405 9.08173C10.9816 9.15364 11.0963 9.26837 11.1683 9.4095C11.25 9.56993 11.25 9.77995 11.25 10.2V15.15C11.25 15.36 11.25 15.465 11.2909 15.5452C11.3268 15.6158 11.3842 15.6732 11.4548 15.7091C11.535 15.75 11.64 15.75 11.85 15.75H13.35C14.1901 15.75 14.6101 15.75 14.931 15.5865C15.2132 15.4427 15.4427 15.2132 15.5865 14.931C15.75 14.6101 15.75 14.1901 15.75 13.35V7.92379C15.75 7.49302 15.75 7.27764 15.6945 7.07929C15.6453 6.90359 15.5645 6.73833 15.456 6.59164C15.3335 6.42604 15.1635 6.29381 14.8235 6.02934L9.73673 2.073Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    info: (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.5 16V12M12.5 8H12.51M22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    lock: (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.625 6.125V4.375C2.625 1.95875 4.58375 0 7 0C9.41625 0 11.375 1.95875 11.375 4.375V6.125H11.8125C12.2957 6.125 12.6875 6.51675 12.6875 7V12.25C12.6875 13.2165 11.904 14 10.9375 14H3.0625C2.096 14 1.3125 13.2165 1.3125 12.25V7C1.3125 6.51675 1.70425 6.125 2.1875 6.125H2.625ZM7 8.3125C6.51675 8.3125 6.125 8.70425 6.125 9.1875V10.9375C6.125 11.4207 6.51675 11.8125 7 11.8125C7.48325 11.8125 7.875 11.4207 7.875 10.9375V9.1875C7.875 8.70425 7.48325 8.3125 7 8.3125ZM9.625 6.125V4.375C9.625 2.92525 8.44975 1.75 7 1.75C5.55025 1.75 4.375 2.92525 4.375 4.375V6.125H9.625Z"
                fill="currentColor"
            />
        </svg>
    ),
    filelock: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="118"
            height="118"
            fill="none"
            viewBox="0 0 118 118"
        >
            <path
                stroke="#6A7383"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="4"
                d="M97.968 48.894V33.248c0-8.215 0-12.323-1.601-15.46a14.681 14.681 0 0 0-6.422-6.41c-3.144-1.6-7.259-1.6-15.489-1.6h-31.35c-8.23 0-12.345 0-15.489 1.6a14.682 14.682 0 0 0-6.422 6.41c-1.601 3.137-1.601 7.245-1.601 15.46v50.849c0 8.215 0 12.322 1.601 15.46a14.68 14.68 0 0 0 6.422 6.41c3.144 1.599 7.259 1.599 15.49 1.599h8.327m12.245-53.783H39.188M53.883 73.34H39.187m39.188-39.114H39.187m55.108 48.893v-8.556c0-4.726-3.838-8.557-8.573-8.557-4.734 0-8.572 3.831-8.572 8.557v8.556m-.735 19.557H95.03c2.744 0 4.115 0 5.163-.532a4.897 4.897 0 0 0 2.141-2.137c.534-1.046.534-2.415.534-5.154v-3.911c0-2.738 0-4.107-.534-5.153a4.895 4.895 0 0 0-2.141-2.137c-1.048-.533-2.42-.533-5.163-.533H76.415c-2.743 0-4.115 0-5.163.533a4.893 4.893 0 0 0-2.14 2.137c-.534 1.046-.534 2.415-.534 5.153v3.912c0 2.738 0 4.107.534 5.153a4.896 4.896 0 0 0 2.14 2.137c1.048.532 2.42.532 5.163.532Z"
            />
        </svg>
    ),
    package: (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.375 5.45831L8.99998 8.99998M8.99998 8.99998L2.62498 5.45831M8.99998 8.99998L9 16.125M15.75 12.0439V5.95609C15.75 5.6991 15.75 5.57061 15.7121 5.45601C15.6786 5.35463 15.6239 5.26157 15.5515 5.18305C15.4697 5.0943 15.3574 5.0319 15.1328 4.9071L9.58277 1.82376C9.37007 1.7056 9.26372 1.64651 9.15109 1.62335C9.05141 1.60285 8.9486 1.60285 8.84891 1.62335C8.73628 1.64651 8.62993 1.7056 8.41723 1.82376L2.86723 4.9071C2.64259 5.0319 2.53026 5.0943 2.44847 5.18305C2.37612 5.26157 2.32136 5.35463 2.28786 5.45602C2.25 5.57061 2.25 5.69911 2.25 5.95609V12.0439C2.25 12.3009 2.25 12.4294 2.28786 12.544C2.32136 12.6454 2.37612 12.7384 2.44847 12.817C2.53026 12.9057 2.64259 12.9681 2.86723 13.0929L8.41723 16.1762C8.62993 16.2944 8.73628 16.3535 8.84891 16.3767C8.9486 16.3972 9.05141 16.3972 9.15109 16.3767C9.26372 16.3535 9.37007 16.2944 9.58277 16.1762L15.1328 13.0929C15.3574 12.9681 15.4697 12.9057 15.5515 12.817C15.6239 12.7384 15.6786 12.6454 15.7121 12.544C15.75 12.4294 15.75 12.3009 15.75 12.0439Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.375 7.125L5.625 3.375"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    pieChart: (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_15_13964)">
                <path
                    d="M15.9078 11.9175C15.4307 13.0459 14.6844 14.0402 13.7342 14.8135C12.784 15.5868 11.6589 16.1156 10.4571 16.3536C9.25538 16.5916 8.01362 16.5316 6.84041 16.1788C5.6672 15.8261 4.59827 15.1913 3.72707 14.33C2.85586 13.4687 2.20891 12.4071 1.84278 11.238C1.47664 10.0689 1.40247 8.82786 1.62675 7.62347C1.85103 6.41908 2.36692 5.28796 3.12934 4.32901C3.89175 3.37006 4.87746 2.61248 6.0003 2.12249M15.9294 6.12987C16.2296 6.85471 16.4138 7.62101 16.4763 8.40062C16.4918 8.59322 16.4995 8.68952 16.4612 8.77627C16.4293 8.84873 16.366 8.9173 16.2963 8.95494C16.2129 8.99999 16.1087 8.99999 15.9003 8.99999H9.6003C9.39028 8.99999 9.28527 8.99999 9.20506 8.95912C9.1345 8.92317 9.07713 8.8658 9.04118 8.79524C9.0003 8.71502 9.0003 8.61001 9.0003 8.39999V2.09999C9.0003 1.89159 9.0003 1.78739 9.04536 1.70398C9.08299 1.6343 9.15156 1.57101 9.22403 1.53906C9.31077 1.50082 9.40707 1.50854 9.59967 1.52398C10.3793 1.58648 11.1456 1.77065 11.8704 2.07089C12.7804 2.4478 13.6072 3.00025 14.3036 3.69669C15 4.39313 15.5525 5.21992 15.9294 6.12987Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_15_13964">
                    <rect width="18" height="18" fill="white" />
                </clipPath>
            </defs>
        </svg>
    ),
    pieChartSmall: (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.3726 9.26913C12.0015 10.1467 11.421 10.9201 10.682 11.5216C9.94297 12.123 9.06786 12.5343 8.13316 12.7194C7.19847 12.9045 6.23265 12.8579 5.32016 12.5835C4.40766 12.3091 3.57627 11.8154 2.89867 11.1455C2.22106 10.4756 1.71788 9.6499 1.43311 8.7406C1.14834 7.83129 1.09065 6.86608 1.26509 5.92933C1.43953 4.99258 1.84078 4.11283 2.43377 3.36698C3.02675 2.62113 3.79342 2.03189 4.66674 1.65079M12.3894 4.76764C12.6229 5.33141 12.7661 5.92742 12.8147 6.53378C12.8268 6.68358 12.8328 6.75848 12.803 6.82595C12.7782 6.88231 12.7289 6.93564 12.6747 6.96492C12.6099 6.99996 12.5288 6.99996 12.3667 6.99996H7.46674C7.30339 6.99996 7.22172 6.99996 7.15933 6.96817C7.10444 6.94021 7.05983 6.89559 7.03186 6.84071C7.00007 6.77832 7.00007 6.69664 7.00007 6.53329V1.63329C7.00007 1.4712 7.00007 1.39016 7.03511 1.32528C7.06439 1.27109 7.11772 1.22186 7.17408 1.19701C7.24155 1.16727 7.31645 1.17327 7.46625 1.18528C8.07261 1.2339 8.66862 1.37714 9.23239 1.61066C9.94013 1.90381 10.5832 2.33349 11.1249 2.87517C11.6665 3.41684 12.0962 4.05991 12.3894 4.76764Z"
                stroke="#6A7383"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    plus: (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.75 5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25Z"
                fill="currentColor"
            />
        </svg>
    ),
    plusSmall: (
        <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5 1.5V8.5M1.5 5H8.5"
                stroke="#30313D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    report: (
        <svg
            width="10"
            height="12"
            viewBox="0 0 10 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6 1.13477V3.20004C6 3.48006 6 3.62007 6.0545 3.72703C6.10243 3.82111 6.17892 3.8976 6.273 3.94554C6.37996 4.00004 6.51997 4.00004 6.8 4.00004H8.86527M6 8.5H3M7 6.5H3M9 4.99411V8.6C9 9.44008 9 9.86012 8.83651 10.181C8.6927 10.4632 8.46323 10.6927 8.18099 10.8365C7.86012 11 7.44008 11 6.6 11H3.4C2.55992 11 2.13988 11 1.81901 10.8365C1.53677 10.6927 1.3073 10.4632 1.16349 10.181C1 9.86012 1 9.44008 1 8.6V3.4C1 2.55992 1 2.13988 1.16349 1.81901C1.3073 1.53677 1.53677 1.3073 1.81901 1.16349C2.13988 1 2.55992 1 3.4 1H5.00589C5.37277 1 5.55622 1 5.72885 1.04145C5.8819 1.07819 6.02822 1.1388 6.16243 1.22104C6.3138 1.3138 6.44352 1.44352 6.70294 1.70294L8.29706 3.29706C8.55648 3.55648 8.6862 3.6862 8.77896 3.83757C8.8612 3.97178 8.92181 4.1181 8.95855 4.27115C9 4.44378 9 4.62723 9 4.99411Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    search: (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.5 18L14.5001 14M15.8333 10.6667C15.8333 13.244 13.744 15.3333 11.1667 15.3333C8.58934 15.3333 6.5 13.244 6.5 10.6667C6.5 8.08934 8.58934 6 11.1667 6C13.744 6 15.8333 8.08934 15.8333 10.6667Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    settings: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.26271 12.9142L6.65234 13.7905C6.76817 14.0514 6.95719 14.273 7.19649 14.4286C7.43579 14.5841 7.71508 14.6669 8.00049 14.6668C8.2859 14.6669 8.56519 14.5841 8.80449 14.4286C9.04378 14.273 9.23281 14.0514 9.34864 13.7905L9.73827 12.9142C9.87696 12.6033 10.1103 12.3441 10.4049 12.1735C10.7015 12.0025 11.0445 11.9296 11.3849 11.9653L12.3383 12.0668C12.622 12.0968 12.9084 12.0439 13.1627 11.9144C13.417 11.7849 13.6283 11.5844 13.7709 11.3372C13.9136 11.0902 13.9817 10.807 13.9667 10.5221C13.9517 10.2372 13.8543 9.9627 13.6864 9.73202L13.122 8.95646C12.921 8.67825 12.8136 8.34337 12.8153 8.00016C12.8152 7.65789 12.9236 7.3244 13.1249 7.04757L13.6894 6.27201C13.8573 6.04133 13.9547 5.76688 13.9696 5.48195C13.9846 5.19701 13.9166 4.91386 13.7738 4.66683C13.6312 4.41965 13.42 4.21916 13.1657 4.08965C12.9114 3.96014 12.625 3.90718 12.3412 3.9372L11.3879 4.03868C11.0474 4.07444 10.7044 4.00158 10.4079 3.83053C10.1126 3.659 9.87928 3.3984 9.74123 3.08609L9.34864 2.20979C9.23281 1.94894 9.04378 1.72731 8.80449 1.57176C8.56519 1.41622 8.2859 1.33345 8.00049 1.3335C7.71508 1.33345 7.43579 1.41622 7.19649 1.57176C6.95719 1.72731 6.76817 1.94894 6.65234 2.20979L6.26271 3.08609C6.12466 3.3984 5.89129 3.659 5.59604 3.83053C5.29952 4.00158 4.95649 4.07444 4.61604 4.03868L3.65975 3.9372C3.37597 3.90718 3.08957 3.96014 2.83529 4.08965C2.58101 4.21916 2.36976 4.41965 2.22715 4.66683C2.08437 4.91386 2.01634 5.19701 2.03133 5.48195C2.04632 5.76688 2.14368 6.04133 2.3116 6.27201L2.87604 7.04757C3.07734 7.3244 3.18574 7.65789 3.18567 8.00016C3.18574 8.34244 3.07734 8.67593 2.87604 8.95276L2.3116 9.72831C2.14368 9.95899 2.04632 10.2335 2.03133 10.5184C2.01634 10.8033 2.08437 11.0865 2.22715 11.3335C2.3699 11.5805 2.58117 11.7809 2.83542 11.9104C3.08967 12.0399 3.37599 12.093 3.65975 12.0631L4.61308 11.9616C4.95353 11.9259 5.29656 11.9987 5.59308 12.1698C5.88943 12.3408 6.12389 12.6015 6.26271 12.9142Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.9993 10.0002C9.10387 10.0002 9.9993 9.10473 9.9993 8.00016C9.9993 6.89559 9.10387 6.00016 7.9993 6.00016C6.89473 6.00016 5.9993 6.89559 5.9993 8.00016C5.9993 9.10473 6.89473 10.0002 7.9993 10.0002Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    server: (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_55_2796)">
                <path
                    d="M4.5 4.5H4.5075M4.5 13.5H4.5075M3.9 7.5H14.1C14.9401 7.5 15.3601 7.5 15.681 7.33651C15.9632 7.1927 16.1927 6.96323 16.3365 6.68099C16.5 6.36012 16.5 5.94008 16.5 5.1V3.9C16.5 3.05992 16.5 2.63988 16.3365 2.31901C16.1927 2.03677 15.9632 1.8073 15.681 1.66349C15.3601 1.5 14.9401 1.5 14.1 1.5H3.9C3.05992 1.5 2.63988 1.5 2.31901 1.66349C2.03677 1.8073 1.8073 2.03677 1.66349 2.31901C1.5 2.63988 1.5 3.05992 1.5 3.9V5.1C1.5 5.94008 1.5 6.36012 1.66349 6.68099C1.8073 6.96323 2.03677 7.1927 2.31901 7.33651C2.63988 7.5 3.05992 7.5 3.9 7.5ZM3.9 16.5H14.1C14.9401 16.5 15.3601 16.5 15.681 16.3365C15.9632 16.1927 16.1927 15.9632 16.3365 15.681C16.5 15.3601 16.5 14.9401 16.5 14.1V12.9C16.5 12.0599 16.5 11.6399 16.3365 11.319C16.1927 11.0368 15.9632 10.8073 15.681 10.6635C15.3601 10.5 14.9401 10.5 14.1 10.5H3.9C3.05992 10.5 2.63988 10.5 2.31901 10.6635C2.03677 10.8073 1.8073 11.0368 1.66349 11.319C1.5 11.6399 1.5 12.0599 1.5 12.9V14.1C1.5 14.9401 1.5 15.3601 1.66349 15.681C1.8073 15.9632 2.03677 16.1927 2.31901 16.3365C2.63988 16.5 3.05992 16.5 3.9 16.5Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_55_2796">
                    <rect width="18" height="18" fill="white" />
                </clipPath>
            </defs>
        </svg>
    ),
    signOut: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.6667 11.3333L14 8M14 8L10.6667 4.66667M14 8H6M6 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.7157 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14H6"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    spinner: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <path
                fill="currentColor"
                d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
            >
                <animateTransform
                    attributeName="transform"
                    dur="0.75s"
                    repeatCount="indefinite"
                    type="rotate"
                    values="0 12 12;360 12 12"
                />
            </path>
        </svg>
    ),
    spinnerBlue: (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <linearGradient
                    id="spinner-gradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                >
                    <stop offset="0%" stopColor="#00ADE0" stopOpacity="1" />
                    <stop offset="100%" stopColor="#007DB7" stopOpacity="1" />
                </linearGradient>
            </defs>
            <circle
                cx="7"
                cy="7"
                r="6"
                stroke="url(#spinner-gradient)"
                strokeWidth="2"
                fill="none"
                strokeLinecap="round"
                strokeDasharray="31.4"
                strokeDashoffset="0"
            >
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 7 7"
                    to="360 7 7"
                    dur="0.75s"
                    repeatCount="indefinite"
                />
            </circle>
        </svg>
    ),
    spinnerBlueThin: (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <linearGradient
                    id="spinner-gradient-thin"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                >
                    <stop offset="0%" stopColor="#00ADE0" stopOpacity="1" />
                    <stop offset="100%" stopColor="#007DB7" stopOpacity="1" />
                </linearGradient>
            </defs>
            <circle
                cx="7"
                cy="7"
                r="6"
                stroke="url(#spinner-gradient-thin)"
                strokeWidth="1"
                fill="none"
                strokeLinecap="round"
                strokeDasharray="31.4"
                strokeDashoffset="0"
            >
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 7 7"
                    to="360 7 7"
                    dur="0.75s"
                    repeatCount="indefinite"
                />
            </circle>
        </svg>
    ),
    stack: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.3335 8L7.76165 11.2141C7.8491 11.2578 7.89283 11.2797 7.9387 11.2883C7.97932 11.2959 8.02101 11.2959 8.06163 11.2883C8.1075 11.2797 8.15122 11.2578 8.23868 11.2141L14.6668 8M1.3335 11.3333L7.76165 14.5474C7.8491 14.5911 7.89283 14.613 7.9387 14.6216C7.97932 14.6292 8.02101 14.6292 8.06163 14.6216C8.1075 14.613 8.15122 14.5911 8.23868 14.5474L14.6668 11.3333M1.3335 4.66667L7.76165 1.45259C7.8491 1.40887 7.89283 1.387 7.9387 1.3784C7.97932 1.37078 8.02101 1.37078 8.06163 1.3784C8.1075 1.387 8.15122 1.40887 8.23868 1.45259L14.6668 4.66667L8.23868 7.88075C8.15122 7.92447 8.1075 7.94634 8.06163 7.95494C8.02101 7.96256 7.97932 7.96256 7.9387 7.95494C7.89283 7.94634 7.8491 7.92447 7.76165 7.88075L1.3335 4.66667Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    switches: (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.75 4.66663L8.75 4.66663M8.75 4.66663C8.75 5.63312 9.5335 6.41663 10.5 6.41663C11.4665 6.41663 12.25 5.63312 12.25 4.66663C12.25 3.70013 11.4665 2.91663 10.5 2.91663C9.5335 2.91663 8.75 3.70013 8.75 4.66663ZM5.25 9.33329L12.25 9.33329M5.25 9.33329C5.25 10.2998 4.4665 11.0833 3.5 11.0833C2.5335 11.0833 1.75 10.2998 1.75 9.33329C1.75 8.36679 2.5335 7.58329 3.5 7.58329C4.4665 7.58329 5.25 8.36679 5.25 9.33329Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    warningCircle: (
        <svg
            width="13"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.5 12C3.18629 12 0.5 9.31371 0.5 6C0.5 2.68629 3.18629 0 6.5 0C9.81371 0 12.5 2.68629 12.5 6C12.5 9.31371 9.81371 12 6.5 12ZM6.5 10.125C7.12132 10.125 7.625 9.62132 7.625 9C7.625 8.37868 7.12132 7.875 6.5 7.875C5.87868 7.875 5.375 8.37868 5.375 9C5.375 9.62132 5.87868 10.125 6.5 10.125ZM6.5 1.5C6.08579 1.5 5.75 1.83579 5.75 2.25V6C5.75 6.41421 6.08579 6.75 6.5 6.75C6.91421 6.75 7.25 6.41421 7.25 6V2.25C7.25 1.83579 6.91421 1.5 6.5 1.5Z"
                fill="currentColor"
            />
        </svg>
    ),
    warningCircleOutline: (
        <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 15V11M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    toastError: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                fill="currentColor"
            />
            <path
                d="M12 13.5615V7"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 16.5615V16.5104"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    toastSuccess: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9.3824 11.0689C9.50441 11.1213 9.61475 11.1975 9.707 11.293L11 12.586L14.293 9.29302C14.3852 9.19751 14.4956 9.12133 14.6176 9.06892C14.7396 9.01651 14.8708 8.98892 15.0036 8.98777C15.1364 8.98662 15.2681 9.01192 15.391 9.0622C15.5138 9.11248 15.6255 9.18673 15.7194 9.28063C15.8133 9.37452 15.8875 9.48617 15.9378 9.60907C15.9881 9.73196 16.0134 9.86364 16.0122 9.99642C16.0111 10.1292 15.9835 10.2604 15.9311 10.3824C15.8787 10.5044 15.8025 10.6148 15.707 10.707L11.707 14.707C11.5195 14.8945 11.2652 14.9998 11 14.9998C10.7348 14.9998 10.4805 14.8945 10.293 14.707L8.293 12.707C8.19749 12.6148 8.1213 12.5044 8.0689 12.3824C8.01649 12.2604 7.9889 12.1292 7.98775 11.9964C7.98659 11.8636 8.0119 11.732 8.06218 11.6091C8.11246 11.4862 8.18671 11.3745 8.2806 11.2806C8.3745 11.1867 8.48615 11.1125 8.60904 11.0622C8.73194 11.0119 8.86362 10.9866 8.9964 10.9878C9.12918 10.9889 9.2604 11.0165 9.3824 11.0689Z"
                fill="currentColor"
            />
        </svg>
    ),
    toastWarning: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="24" height="24" fill="white" fillOpacity="0.01" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8ZM12 10C12.5523 10 13 10.4477 13 11V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V11C11 10.4477 11.4477 10 12 10Z"
                fill="currentColor"
            />
        </svg>
    ),
    warningTriangle: (
        <svg
            width="11"
            height="10"
            viewBox="0 0 11 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.86511 0.817553L10.3866 7.86047C10.7517 8.59075 10.4557 9.47878 9.72542 9.84392C9.52013 9.94656 9.29377 10 9.06426 10H2.02135C1.20486 10 0.542969 9.33811 0.542969 8.52162C0.542969 8.29211 0.596405 8.06575 0.699046 7.86047L4.2205 0.817553C4.58565 0.0872644 5.47367 -0.208744 6.20396 0.156401C6.49007 0.299455 6.72206 0.531446 6.86511 0.817553ZM5.54297 6.5625C5.0252 6.5625 4.60547 6.98223 4.60547 7.5C4.60547 8.01777 5.0252 8.4375 5.54297 8.4375C6.06074 8.4375 6.48047 8.01777 6.48047 7.5C6.48047 6.98223 6.06074 6.5625 5.54297 6.5625ZM5.54297 5.625C5.88815 5.625 6.16797 5.42513 6.16797 5.17857V2.94643C6.16797 2.69987 5.88815 2.5 5.54297 2.5C5.19779 2.5 4.91797 2.69987 4.91797 2.94643V5.17857C4.91797 5.42513 5.19779 5.625 5.54297 5.625Z"
                fill="currentColor"
            />
        </svg>
    ),
    warningTriangleLight: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    parthenon: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2 14H14M4 12V6.66665M6.66667 12V6.66665M9.33333 12V6.66665M12 12V6.66665M13.3333 4.66665L8.28267 1.50998C8.18012 1.44589 8.12885 1.41385 8.07386 1.40135C8.02524 1.3903 7.97476 1.3903 7.92614 1.40135C7.87115 1.41385 7.81988 1.44589 7.71733 1.50998L2.66667 4.66665H13.3333Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    refresh: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.6667 6.66667C14.6667 6.66667 13.33 4.84548 12.2441 3.75883C11.1582 2.67218 9.6576 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C10.7354 14 13.0433 12.1695 13.7655 9.66667M14.6667 6.66667V2.66667M14.6667 6.66667H10.6667"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    repeat: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.33334 1.3335L9.33334 3.3335M9.33334 3.3335L7.33334 5.3335M9.33334 3.3335H4.53334C3.41324 3.3335 2.85319 3.3335 2.42536 3.55148C2.04904 3.74323 1.74308 4.04919 1.55133 4.42552C1.33334 4.85334 1.33334 5.41339 1.33334 6.5335V10.3335C1.33334 10.6431 1.33334 10.7979 1.35045 10.9279C1.46861 11.8253 2.17482 12.5316 3.07229 12.6497C3.20226 12.6668 3.35706 12.6668 3.66668 12.6668M6.66668 12.6668H11.4667C12.5868 12.6668 13.1468 12.6668 13.5747 12.4488C13.951 12.2571 14.2569 11.9511 14.4487 11.5748C14.6667 11.147 14.6667 10.5869 14.6667 9.46683V5.66683C14.6667 5.35722 14.6667 5.20241 14.6496 5.07244C14.5314 4.17498 13.8252 3.46876 12.9277 3.35061C12.7978 3.3335 12.643 3.3335 12.3333 3.3335M6.66668 12.6668L8.66668 14.6668M6.66668 12.6668L8.66668 10.6668"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    sidebarOff: (
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.71858 2.70082e-07H11.7814C12.4548 -8.4918e-06 13.0055 -1.56462e-05 13.4531 0.0365518C13.9163 0.0744017 14.3347 0.155137 14.7255 0.35423C15.337 0.665818 15.8342 1.163 16.1458 1.77453C16.3449 2.16527 16.4256 2.58367 16.4634 3.04693C16.5 3.49449 16.5 4.04519 16.5 4.71856V11.7814C16.5 12.4548 16.5 13.0055 16.4634 13.4531C16.4256 13.9163 16.3449 14.3347 16.1458 14.7255C15.8342 15.337 15.337 15.8342 14.7255 16.1458C14.3347 16.3449 13.9163 16.4256 13.4531 16.4634C13.0055 16.5 12.4548 16.5 11.7814 16.5H4.71856C4.04519 16.5 3.49449 16.5 3.04693 16.4634C2.58367 16.4256 2.16527 16.3449 1.77453 16.1458C1.163 15.8342 0.665818 15.337 0.35423 14.7255C0.155137 14.3347 0.0744017 13.9163 0.0365518 13.4531C-1.56462e-05 13.0055 -8.4918e-06 12.4548 2.70082e-07 11.7814V4.71858C-8.4918e-06 4.0452 -1.56462e-05 3.4945 0.0365518 3.04693C0.0744017 2.58367 0.155137 2.16527 0.354229 1.77453C0.665818 1.163 1.163 0.665818 1.77453 0.354229C2.16527 0.155137 2.58367 0.0744017 3.04693 0.0365518C3.4945 -1.56462e-05 4.0452 -8.4918e-06 4.71858 2.70082e-07ZM11.5 15H11.75C12.4624 15 12.9517 14.9994 13.3309 14.9684C13.7014 14.9382 13.9004 14.8827 14.0445 14.8093C14.3738 14.6415 14.6415 14.3738 14.8093 14.0445C14.8827 13.9004 14.9382 13.7014 14.9684 13.3309C14.9994 12.9517 15 12.4624 15 11.75V4.75C15 4.03756 14.9994 3.54833 14.9684 3.16908C14.9382 2.79858 14.8827 2.59956 14.8093 2.45552C14.6415 2.12623 14.3738 1.85852 14.0445 1.69074C13.9004 1.61735 13.7014 1.56184 13.3309 1.53157C12.9517 1.50058 12.4624 1.5 11.75 1.5H11.5V15ZM10 1.5V15H4.75C4.03756 15 3.54833 14.9994 3.16908 14.9684C2.79858 14.9382 2.59956 14.8827 2.45552 14.8093C2.12623 14.6415 1.85852 14.3738 1.69074 14.0445C1.61735 13.9004 1.56184 13.7014 1.53157 13.3309C1.50058 12.9517 1.5 12.4624 1.5 11.75V4.75C1.5 4.03756 1.50058 3.54833 1.53157 3.16908C1.56184 2.79858 1.61735 2.59956 1.69074 2.45552C1.85852 2.12623 2.12623 1.85852 2.45552 1.69074C2.59956 1.61735 2.79858 1.56184 3.16908 1.53157C3.54833 1.50058 4.03756 1.5 4.75 1.5H10Z"
                fill="#6A7383"
            />
        </svg>
    ),
    sidebarOn: (
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.71858 2.70124e-07H11.7814C12.4548 -8.49176e-06 13.0055 -1.57021e-05 13.4531 0.0365517C13.9163 0.0744017 14.3347 0.155137 14.7255 0.354229C15.337 0.665817 15.8342 1.163 16.1458 1.77453C16.3449 2.16527 16.4256 2.58367 16.4634 3.04693C16.5 3.49449 16.5 4.04519 16.5 4.71856V11.7814C16.5 12.4548 16.5 13.0055 16.4634 13.4531C16.4256 13.9163 16.3449 14.3347 16.1458 14.7255C15.8342 15.337 15.337 15.8342 14.7255 16.1458C14.3347 16.3449 13.9163 16.4256 13.4531 16.4634C13.0055 16.5 12.4548 16.5 11.7814 16.5H4.71856C4.04519 16.5 3.49449 16.5 3.04693 16.4634C2.58367 16.4256 2.16527 16.3449 1.77453 16.1458C1.163 15.8342 0.665817 15.337 0.354229 14.7255C0.155137 14.3347 0.0744014 13.9163 0.0365515 13.4531C-1.59144e-05 13.0055 -8.76188e-06 12.4548 0 11.7814V4.71858C-8.76188e-06 4.0452 -1.59144e-05 3.4945 0.0365515 3.04693C0.0744014 2.58367 0.155137 2.16527 0.354229 1.77453C0.665817 1.163 1.163 0.665818 1.77453 0.354229C2.16527 0.155137 2.58367 0.0744017 3.04693 0.0365517C3.4945 -1.57021e-05 4.0452 -8.49176e-06 4.71858 2.70124e-07ZM10 1.5V15H4.75C4.03756 15 3.54833 14.9994 3.16908 14.9684C2.79858 14.9382 2.59956 14.8827 2.45552 14.8093C2.12623 14.6415 1.85852 14.3738 1.69074 14.0445C1.61735 13.9004 1.56184 13.7014 1.53157 13.3309C1.50058 12.9517 1.5 12.4624 1.5 11.75V4.75C1.5 4.03756 1.50058 3.54833 1.53157 3.16908C1.56184 2.79858 1.61735 2.59956 1.69074 2.45552C1.85852 2.12623 2.12623 1.85852 2.45552 1.69074C2.59956 1.61735 2.79858 1.56184 3.16908 1.53157C3.54833 1.50058 4.03756 1.5 4.75 1.5H10Z"
                fill="#6A7383"
            />
        </svg>
    ),
    trash: (
        <svg
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.66667 4.00016V3.46683C9.66667 2.72009 9.66667 2.34672 9.52134 2.06151C9.39351 1.81063 9.18954 1.60665 8.93865 1.47882C8.65344 1.3335 8.28007 1.3335 7.53333 1.3335H6.46667C5.71993 1.3335 5.34656 1.3335 5.06135 1.47882C4.81046 1.60665 4.60649 1.81063 4.47866 2.06151C4.33333 2.34672 4.33333 2.72009 4.33333 3.46683V4.00016M5.66667 7.66683V11.0002M8.33333 7.66683V11.0002M1 4.00016H13M11.6667 4.00016V11.4668C11.6667 12.5869 11.6667 13.147 11.4487 13.5748C11.2569 13.9511 10.951 14.2571 10.5746 14.4488C10.1468 14.6668 9.58677 14.6668 8.46667 14.6668H5.53333C4.41323 14.6668 3.85318 14.6668 3.42535 14.4488C3.04903 14.2571 2.74307 13.9511 2.55132 13.5748C2.33333 13.147 2.33333 12.5869 2.33333 11.4668V4.00016"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    upload: (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.25 8.75012V9.45012C12.25 10.4302 12.25 10.9203 12.0593 11.2946C11.8915 11.6239 11.6238 11.8916 11.2945 12.0594C10.9201 12.2501 10.4301 12.2501 9.45 12.2501H4.55C3.56991 12.2501 3.07986 12.2501 2.70552 12.0594C2.37623 11.8916 2.10852 11.6239 1.94074 11.2946C1.75 10.9203 1.75 10.4302 1.75 9.45012V8.75012M9.91667 4.66679L7 1.75012M7 1.75012L4.08333 4.66679M7 1.75012V8.75012"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    userCircle: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_958_8402)">
                <path
                    d="M3.54387 12.9591C3.94942 12.0036 4.89629 11.3335 5.99967 11.3335H9.99967C11.1031 11.3335 12.0499 12.0036 12.4555 12.9591M10.6663 6.3335C10.6663 7.80626 9.47243 9.00016 7.99967 9.00016C6.52692 9.00016 5.33301 7.80626 5.33301 6.3335C5.33301 4.86074 6.52692 3.66683 7.99967 3.66683C9.47243 3.66683 10.6663 4.86074 10.6663 6.3335ZM14.6663 8.00016C14.6663 11.6821 11.6816 14.6668 7.99967 14.6668C4.31778 14.6668 1.33301 11.6821 1.33301 8.00016C1.33301 4.31826 4.31778 1.3335 7.99967 1.3335C11.6816 1.3335 14.6663 4.31826 14.6663 8.00016Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_958_8402">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    ),
    user: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.3327 14C13.3327 13.0696 13.3327 12.6044 13.2179 12.2259C12.9593 11.3736 12.2924 10.7067 11.4401 10.4482C11.0616 10.3333 10.5964 10.3333 9.66601 10.3333H6.33268C5.40231 10.3333 4.93712 10.3333 4.55859 10.4482C3.70632 10.7067 3.03938 11.3736 2.78084 12.2259C2.66602 12.6044 2.66602 13.0696 2.66602 14M10.9993 5C10.9993 6.65685 9.6562 8 7.99935 8C6.34249 8 4.99935 6.65685 4.99935 5C4.99935 3.34315 6.34249 2 7.99935 2C9.6562 2 10.9993 3.34315 10.9993 5Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    users: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.9999 10.5579C12.9705 11.0455 13.8026 11.828 14.4101 12.8064C14.5303 13.0002 14.5905 13.0971 14.6113 13.2312C14.6535 13.5038 14.4671 13.839 14.2132 13.9469C14.0882 14 13.9477 14 13.6666 14M10.6666 7.68816C11.6544 7.19726 12.3332 6.17791 12.3332 5C12.3332 3.82209 11.6544 2.80274 10.6666 2.31184M9.33322 5C9.33322 6.65685 7.99008 8 6.33322 8C4.67637 8 3.33322 6.65685 3.33322 5C3.33322 3.34315 4.67637 2 6.33322 2C7.99008 2 9.33322 3.34315 9.33322 5ZM1.70604 12.6256C2.76892 11.0297 4.44614 10 6.33322 10C8.22031 10 9.89753 11.0297 10.9604 12.6256C11.1932 12.9752 11.3097 13.15 11.2963 13.3733C11.2858 13.5471 11.1719 13.76 11.0329 13.8651C10.8545 14 10.6091 14 10.1183 14H2.54813C2.05734 14 1.81194 14 1.63352 13.8651C1.49459 13.76 1.38062 13.5471 1.37018 13.3733C1.35678 13.15 1.4732 12.9752 1.70604 12.6256Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    zoomOut: (
        <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="iconamoon:zoom-out">
                <path
                    id="Vector"
                    d="M14.5 13.9999L11.6047 11.1046M11.6047 11.1046C12.0999 10.6093 12.4928 10.0213 12.7608 9.37426C13.0289 8.72717 13.1668 8.03363 13.1668 7.33323C13.1668 6.63283 13.0289 5.93928 12.7608 5.2922C12.4928 4.64511 12.0999 4.05715 11.6047 3.56189C11.1094 3.06663 10.5215 2.67377 9.87438 2.40574C9.22729 2.13771 8.53375 1.99976 7.83335 1.99976C7.13295 1.99976 6.4394 2.13771 5.79232 2.40574C5.14523 2.67377 4.55727 3.06663 4.06202 3.56189C3.0618 4.56211 2.49988 5.9187 2.49988 7.33323C2.49988 8.74775 3.0618 10.1043 4.06202 11.1046C5.06224 12.1048 6.41882 12.6667 7.83335 12.6667C9.24787 12.6667 10.6045 12.1048 11.6047 11.1046ZM5.83335 7.33323H9.83335"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    ),
    zoomIn: (
        <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="lucide:zoom-in">
                <g id="Group">
                    <path
                        id="Vector"
                        d="M7.83333 12.6667C10.7789 12.6667 13.1667 10.2789 13.1667 7.33333C13.1667 4.38781 10.7789 2 7.83333 2C4.88781 2 2.5 4.38781 2.5 7.33333C2.5 10.2789 4.88781 12.6667 7.83333 12.6667Z"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_2"
                        d="M14.5 13.9999L11.6 11.0999M7.83331 5.33325V9.33325M5.83331 7.33325H9.83331"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
        </svg>
    ),
    edit: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.33331 2.66666H4.53331C3.41321 2.66666 2.85316 2.66666 2.42533 2.88464C2.04901 3.07639 1.74305 3.38235 1.5513 3.75867C1.33331 4.1865 1.33331 4.74655 1.33331 5.86666V11.4667C1.33331 12.5868 1.33331 13.1468 1.5513 13.5746C1.74305 13.951 2.04901 14.2569 2.42533 14.4487C2.85316 14.6667 3.41321 14.6667 4.53331 14.6667H10.1333C11.2534 14.6667 11.8135 14.6667 12.2413 14.4487C12.6176 14.2569 12.9236 13.951 13.1153 13.5746C13.3333 13.1468 13.3333 12.5868 13.3333 11.4667V8.66666M5.3333 10.6667H6.44966C6.77578 10.6667 6.93884 10.6667 7.09229 10.6298C7.22834 10.5972 7.3584 10.5433 7.47769 10.4702C7.61225 10.3877 7.72755 10.2724 7.95815 10.0418L14.3333 3.66666C14.8856 3.11437 14.8856 2.21894 14.3333 1.66666C13.781 1.11437 12.8856 1.11437 12.3333 1.66665L5.95814 8.04182C5.72753 8.27242 5.61223 8.38772 5.52978 8.52228C5.45667 8.64157 5.4028 8.77163 5.37014 8.90768C5.3333 9.06113 5.3333 9.22419 5.3333 9.55031V10.6667Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    xCircle: (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    checkCircle: (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    slashCircle: (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.93 4.93L19.07 19.07M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    upArrow: (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6 11V1M6 1L1 6M6 1L11 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    topArrow: (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 1H1M6 11V3.22222M6 3.22222L2.11111 7.11111M6 3.22222L9.88889 7.11111"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    bottomArrow: (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 11H11M6 1V8.77778M6 8.77778L9.88889 4.88889M6 8.77778L2.11111 4.88889"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    downArrow: (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6 1V11M6 11L11 6M6 11L1 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
}

export type IconName = keyof typeof iconsList

const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

export const Icon = ({
    name,
    className,
    style,
}: {
    name: IconName
    className?: string
    style?: CSSProperties
}) => (
    <IconContainer className={className} style={style}>
        {iconsList[name]}
    </IconContainer>
)
